import React, { useRef } from 'react';
import { Form } from '@thinknet-gmbh/platform-common-ui';
import SignatureCanvas from 'react-signature-canvas';

import { StyledSignatureWrapper, SignatureContainer } from './signature.styles';
import { IQuestionnaireFieldProps } from '../form-item-field/form-item-field.intrrface';
import { useTranslation } from 'react-i18next';

export const signatureUpload = ({
  canvas,
  setFieldsValue,
}: {
  canvas: any;
  setFieldsValue: Function;
}) => {
  return new Promise(resolve => {
    canvas.toBlob((blob: Blob) => {
      resolve(blob);
    });
  }).then((blob: any) => {
    setFieldsValue({
      signatureId: new File([blob], 'signature.png', {
        type: blob.type,
      }),
    });
  });
};

const Signature = ({ label, name, rules }: IQuestionnaireFieldProps) => {
  const { t } = useTranslation('employee');
  const signRef = useRef({} as any);
  return (
    <StyledSignatureWrapper>
      <Form.Item noStyle shouldUpdate>
        {({ setFieldsValue }) => {
          return (
            <Form.Item className={'signature-container'} name={name} label={label} rules={rules}>
              <SignatureContainer>
                <SignatureCanvas
                  penColor={'#3B94BF'}
                  maxWidth={1.5}
                  ref={signRef}
                  onEnd={() => {
                    if (!signRef.current.isEmpty()) {
                      const canvas = signRef.current.getCanvas();
                      signatureUpload({
                        canvas,
                        setFieldsValue,
                      });
                    }
                  }}
                  clearOnResize={true}
                  canvasProps={{
                    width: 'auto',
                    height: 102,
                    className: 'signature-field',
                  }}
                />
                <span
                  className={'ant-btn'}
                  onClick={() => {
                    setFieldsValue({
                      signatureId: null,
                    });
                    signRef.current.clear();
                  }}
                >
                  {t('common:buttons.clear')}
                </span>
              </SignatureContainer>
            </Form.Item>
          );
        }}
      </Form.Item>
    </StyledSignatureWrapper>
  );
};

export default Signature;
